<template>
  <qx-card-form title="承运信息" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="mileageNumberTip">
        <span class="error" style="margin-left: 16px" v-show="calcIng">距离计算中...</span>
      </span>
      <section slot="squareAndWeight">
        <el-input
          class="appendInputBox"
          v-model="otherFormData.square"
          placeholder="体积"
          @blur="calCostPrice"
        >
          <span slot="suffix">
            <span class="unit">立方</span>
<!--            <el-input-->
<!--              class="inputAppendInput"-->
<!--              v-model="otherFormData.weight"-->
<!--              :clear="true"-->
<!--              placeholder="重量"-->
<!--              @blur="calCostPrice"-->
<!--            >-->
<!--              <span class="unit" slot="suffix">吨</span>-->
<!--            </el-input>-->
          </span>
        </el-input>
      </section>
      <section slot="Weight">
        <el-input
            class="appendInputBox"
            v-model="otherFormData.weight"
            placeholder="重量"
            @blur="calCostPrice"
            @change="weightChange"
        >
          <span slot="suffix">
            <span class="unit">吨</span>
            <el-input
                class="inputAppendInput"
                v-model="kilogram"
                :clear="true"
                placeholder="重量"
                @blur="calCostPrice"
                @change="kilogramChange"
            >
              <span class="unit" slot="suffix">KG</span>
            </el-input>
          </span>
        </el-input>
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import {floatMutiply, floatReduce, isNegativeNumber} from '@qx/utils';
import {mapState} from 'vuex';
export default {
  data () {
    return {
      calcIng: false,
      otherFormData: {
        square: '0',
        weight: '0',
      },
      kilogram: '',
      baseForm: {
        goodsTypeOptions: [],
        vehicleStatusOptions: [],
        inline: true,
        form: [
          {
            label: '承运方公里数',
            value: 'mileageNumber',
            type: 'input',
          },
          {
            label: '货品名称',
            value: 'goodsName',
            type: 'input',
          },
          {
            label: '货品类型',
            value: 'goodsType',
            type: 'select',
            default: '1',
          },
          {
            label: '体积',
            value: 'squareAndWeight',
            slot: true,
          },
          {
            label: '重量',
            value: 'Weight',
            slot: true,
          },
          {
            label: '车型要求',
            value: 'vehicleStatus',
            type: 'cascader',
            normal: true,
            default: [],
            hide: false,
          },
          {
            label: '计划数量',
            value: 'goodsNumber',
            type: 'input',
            unit: '件',
            onChange: () => {
              const goodsNumber = this.$refs.baseForm.getVal('goodsNumber');
              this.$refs.baseForm.setVal('goodsNumber', isNegativeNumber(goodsNumber));
              this.calCostPrice();
            },
          },
        ],
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setDistant (distance) {
      // 客户公里数
      this.$refs.baseForm.setVal('mileageNumber', distance);
    },
    setList (options) {
      this.baseForm.goodsTypeOptions = options[0];
      this.baseForm.vehicleStatusOptions = options[1];
    },
    // 计算单价
    calCostPrice () {
      this.otherFormData.square = isNegativeNumber(Number(this.otherFormData.square));
      this.$emit('calCostPrice', 'carriageForm');
    },
    weightChange () {
      this.otherFormData.weight = isNegativeNumber(Number(this.otherFormData.weight));
      if (this.otherFormData.weight !== 0) {
        this.kilogram = floatMutiply(Number(this.otherFormData.weight), 1000);
      }
    },
    kilogramChange () {
      this.kilogram = isNegativeNumber(Number(this.kilogram));
      if (this.kilogram !== 0) {
        this.otherFormData.weight = floatReduce(Number(this.kilogram), 1000);
      }
    },
    setData (data) {
      let info = {
        mileageNumber: data.line.mileageNumber,
        goodsName: data.line.goodsName,
        goodsType: data.line.goodsType ? `${data.line.goodsType}` : '1',
        vehicleStatus: [data.line.vehicleStatus, data.line.vehicleLength],
        goodsNumber: data.line.goodsNumber,
      };
      this.otherFormData.square = data.line.goodsVolume || '0';
      this.otherFormData.weight = data.line.goodsWeight || '0';
      this.kilogram = data.line.goodsWeight * 1000 || '0';
      this.$refs.baseForm.setVal('form', info);
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        if (!formData.square) {
          // 如果不填 体积 的话，订单录入会报错
          formData.square = '0';
        }
        if (!formData.weight) {
          // 如果不填 重量 的话，订单录入会报错
          formData.weight = '0';
        }
        const customerInfo = {};
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            if (name === 'vehicleStatus') {
              if (formData[name].length) {
                customerInfo['customerInfo.vehicleStatus'] = formData[name][0];
                customerInfo['customerInfo.vehicleLengh'] = formData[name][1];
              }
            } else {
              customerInfo['customerInfo.' + name] = formData[name];
            }
          }
        }
        formData = customerInfo;
      }
      return formData;
    },
    setDetailData (data) {
      if (data.orderScheduler) {
        data.mileageNumber = data.orderScheduler.mileageNumber / 1000;
      }

      if (data.orderGoods) {
        data.goodsName = data.orderGoods.goodsName;
        data.goodsType = `${data.orderGoods.goodsType}`;
        data.vehicleStatus = [`${data.orderGoods.vehicleStatus}`, `${data.orderGoods.vehicleLengh}`];

        data.goodsNumber = data.orderGoods.nums;
        this.otherFormData.square = data.orderGoods.square || '0';
        this.otherFormData.weight = data.orderGoods.weight || '0';
        this.kilogram = data.orderGoods.weight * 1000 || '0';
      }
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.setFormVal(this.otherFormData, data);
      this.setDetailData(data);
      this.$refs.baseForm.setVal(data);
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息

    }),
  },
  created () {
    this.setFormAttrVal({ // 姓名
      form: this.baseForm,
      attr: 'hide',
      value: this.userInfo.staffTFInfo.tenantId === 2531 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538,
      names: ['vehicleStatus'],
    });
  },
};
</script>
<style lang="scss" scoped>
</style>
